import styled from 'styled-components';
import { Link } from '../buttons';

export const SwitchGroupLink = styled(Link)`
    font-size: 14px;
`;
